/* estilos-1 (Bloque E, apunte 1): EL REGRESO SUELTA LA RUEDITA DE APPLE Y GOOGLE.

   ARCHIVO EN ASCII A PROPOSITO (regla de la casa para los `.js` nuevos).

   Las pantallas de entrar y de crear cuenta ponen a girar el boton de Apple o de Google al tocarlo y no lo apagan:
   en la web la pagina se va al proveedor (`window.location.href`), y en la app la hoja del sistema apaga la ruedita al
   contestar. Pero hay dos regresos en los que nadie la apaga:
     . en la web, el boton de atras (o el gesto del iPhone) restaura la pagina de la cache de ida y vuelta (bfcache)
       CON su estado de React: la ruedita sigue y los dos botones siguen apagados;
     . en la app, una hoja que se cierra sin que el plugin conteste deja la llamada colgada para siempre.
   Este gancho llama a `soltar` en cada una de esas senales de "volvi a esta pantalla":
     . `pageshow` con `persisted` (la pagina salio de la bfcache; sin `persisted` es una carga nueva y el estado ya
       nace limpio, asi que no se toca);
     . `popstate` (el historial regreso a esta entrada);
     . `visibilitychange` a visible (la pestana o la app volvio a primer plano). El repo no trae `@capacitor/app`
       (lo dice App.js), asi que en la app esta es la senal de la casa para "volvio del segundo plano", la misma que
       usan AuthContext, el Panel y la bodega.
   `soltar` puede cambiar en cada render: se lee de una referencia, y los oyentes se ponen una sola vez. */
import { useEffect, useRef } from 'react';

export function useSoltarAlRegresar(soltar) {
  const ref = useRef(soltar);
  useEffect(() => { ref.current = soltar; }, [soltar]);

  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return undefined;
    const llamar = () => { if (typeof ref.current === 'function') ref.current(); };
    const alMostrar = (e) => { if (e && e.persisted) llamar(); };
    const alNavegar = () => llamar();
    const alVolver = () => { if (document.visibilityState === 'visible') llamar(); };
    window.addEventListener('pageshow', alMostrar);
    window.addEventListener('popstate', alNavegar);
    document.addEventListener('visibilitychange', alVolver);
    return () => {
      window.removeEventListener('pageshow', alMostrar);
      window.removeEventListener('popstate', alNavegar);
      document.removeEventListener('visibilitychange', alVolver);
    };
  }, []);
}

export default useSoltarAlRegresar;
